import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ICONS } from './icons.constants';

@Component({
    selector: 'app-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.css']
})
export class IconComponent {
    @Input() name: string = '';
    @Input() width: string = '24';
    @Input() height: string = '24';
    @Input() fill: string = 'none';
    @Input() stroke: string = 'currentColor';
    @Input() class: string = '';

    constructor(private sanitizer: DomSanitizer) { }

    get iconSvg(): SafeHtml {
        const iconData = ICONS[this.name];
        if (!iconData) {
            // console.warn(`Icon "${this.name}" not found`); //__CONSOLE_LOG__
            return '';
        }

        // Build the SVG with dynamic attributes
        const svg = `
      <svg 
        width="${this.width}" 
        height="${this.height}" 
        viewBox="${iconData.viewBox}" 
        fill="${this.fill}" 
        xmlns="http://www.w3.org/2000/svg"
        class="${this.class}"
        ${iconData.stroke ? `stroke="${this.stroke}"` : ''}
      >
        ${iconData.path}
      </svg>
    `;

        return this.sanitizer.bypassSecurityTrustHtml(svg);
    }
}
